import { c as _c } from "react/compiler-runtime";
import type { DocumentImageError } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useFailureReasonText = () => {
  const $ = _c(92);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "fieldset.documents.details.failureReasons"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp5);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp6);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp7);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp8);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp9);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp10);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp11);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t(_temp12);
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t(_temp13);
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t(_temp14);
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t(_temp15);
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t) {
    t16 = t(_temp16);
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t) {
    t17 = t(_temp17);
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t) {
    t18 = t(_temp18);
    $[35] = t;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t(_temp19);
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t) {
    t20 = t(_temp20);
    $[39] = t;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t) {
    t21 = t(_temp21);
    $[41] = t;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t) {
    t22 = t(_temp22);
    $[43] = t;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t) {
    t23 = t(_temp23);
    $[45] = t;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t) {
    t24 = t(_temp24);
    $[47] = t;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t) {
    t25 = t(_temp25);
    $[49] = t;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t) {
    t26 = t(_temp26);
    $[51] = t;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t) {
    t27 = t(_temp27);
    $[53] = t;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t) {
    t28 = t(_temp28);
    $[55] = t;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== t) {
    t29 = t(_temp29);
    $[57] = t;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  let t30;
  if ($[59] !== t1 || $[60] !== t10 || $[61] !== t11 || $[62] !== t12 || $[63] !== t13 || $[64] !== t14 || $[65] !== t15 || $[66] !== t16 || $[67] !== t17 || $[68] !== t18 || $[69] !== t19 || $[70] !== t2 || $[71] !== t20 || $[72] !== t21 || $[73] !== t22 || $[74] !== t23 || $[75] !== t24 || $[76] !== t25 || $[77] !== t26 || $[78] !== t27 || $[79] !== t28 || $[80] !== t29 || $[81] !== t3 || $[82] !== t4 || $[83] !== t5 || $[84] !== t6 || $[85] !== t7 || $[86] !== t8 || $[87] !== t9) {
    t30 = {
      doc_type_mismatch: t1,
      unknown_document_type: t2,
      unsupported_document_type: t3,
      wrong_document_side: t4,
      wrong_one_sided_document: t5,
      document_not_readable: t6,
      document_glare: t7,
      document_sharpness: t8,
      unable_to_align_document: t9,
      id_type_not_acceptable: t10,
      unknown_country_code: t11,
      country_code_mismatch: t12,
      selfie_face_not_found: t13,
      selfie_low_confidence: t14,
      selfie_too_dark: t15,
      selfie_glare: t16,
      selfie_has_lenses: t17,
      selfie_has_face_mask: t18,
      selfie_blurry: t19,
      selfie_image_size_unsupported: t20,
      selfie_image_orientation_incorrect: t21,
      selfie_bad_image_compression: t22,
      selfie_video_missing: t23,
      drivers_license_permit_not_allowed: t24,
      unknown_error: t25,
      face_not_found: t26,
      multiple_faces_detected: t27,
      military_id_not_allowed: t28,
      custom_document_not_recognized: t29
    };
    $[59] = t1;
    $[60] = t10;
    $[61] = t11;
    $[62] = t12;
    $[63] = t13;
    $[64] = t14;
    $[65] = t15;
    $[66] = t16;
    $[67] = t17;
    $[68] = t18;
    $[69] = t19;
    $[70] = t2;
    $[71] = t20;
    $[72] = t21;
    $[73] = t22;
    $[74] = t23;
    $[75] = t24;
    $[76] = t25;
    $[77] = t26;
    $[78] = t27;
    $[79] = t28;
    $[80] = t29;
    $[81] = t3;
    $[82] = t4;
    $[83] = t5;
    $[84] = t6;
    $[85] = t7;
    $[86] = t8;
    $[87] = t9;
    $[88] = t30;
  } else {
    t30 = $[88];
  }
  const errorToText = t30;
  let t31;
  if ($[89] !== errorToText || $[90] !== t) {
    t31 = reason => t(_temp30, {
      reason: errorToText[reason]
    });
    $[89] = errorToText;
    $[90] = t;
    $[91] = t31;
  } else {
    t31 = $[91];
  }
  return t31;
};
export default useFailureReasonText;
function _temp($) {
  return $.docTypeMismatch;
}
function _temp2($_0) {
  return $_0.unknownDocumentType;
}
function _temp3($_1) {
  return $_1.unsupportedDocumentType;
}
function _temp4($_2) {
  return $_2.wrongDocumentSide;
}
function _temp5($_3) {
  return $_3.wrongOneSidedDocument;
}
function _temp6($_4) {
  return $_4.documentNotReadable;
}
function _temp7($_5) {
  return $_5.documentGlare;
}
function _temp8($_6) {
  return $_6.documentSharpness;
}
function _temp9($_7) {
  return $_7.unableToAlignDocument;
}
function _temp10($_8) {
  return $_8.idTypeNotAcceptable;
}
function _temp11($_9) {
  return $_9.unknownCountryCode;
}
function _temp12($_10) {
  return $_10.countryCodeMismatch;
}
function _temp13($_11) {
  return $_11.selfieFaceNotFound;
}
function _temp14($_12) {
  return $_12.selfieLowConfidence;
}
function _temp15($_13) {
  return $_13.selfieTooDark;
}
function _temp16($_14) {
  return $_14.selfieGlare;
}
function _temp17($_15) {
  return $_15.selfieHasLenses;
}
function _temp18($_16) {
  return $_16.selfieHasFaceMask;
}
function _temp19($_17) {
  return $_17.selfieBlurry;
}
function _temp20($_18) {
  return $_18.selfieImageSizeUnsupported;
}
function _temp21($_19) {
  return $_19.selfieImageOrientationIncorrect;
}
function _temp22($_20) {
  return $_20.selfieBadImageCompression;
}
function _temp23($_21) {
  return $_21.selfieVideoMissing;
}
function _temp24($_22) {
  return $_22.driversLicensePermitNotAllowed;
}
function _temp25($_23) {
  return $_23.unknownError;
}
function _temp26($_24) {
  return $_24.faceNotFound;
}
function _temp27($_25) {
  return $_25.multipleFacesDetected;
}
function _temp28($_26) {
  return $_26.militaryIdNotAllowed;
}
function _temp29($_27) {
  return $_27.customDocumentNotRecognized;
}
function _temp30($_28) {
  return $_28.preface;
}